var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarGrey2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.474 18.0547H2.2675C1.22554 18.0547 0.380859 17.2588 0.380859 16.277V3.8334C0.380859 2.85163 1.22554 2.05574 2.2675 2.05574H4.15415V0.278076H6.0408V2.05574H11.7007V0.278076H13.5874V2.05574H15.474C16.516 2.05574 17.3607 2.85163 17.3607 3.8334V16.277C17.3607 17.2588 16.516 18.0547 15.474 18.0547ZM2.2675 7.38873V16.277H15.474V7.38873H2.2675ZM2.2675 3.8334V5.61106H15.474V3.8334H2.2675ZM13.5874 14.4994H11.7007V12.7217H13.5874V14.4994ZM9.81409 14.4994H7.92744V12.7217H9.81409V14.4994ZM6.0408 14.4994H4.15415V12.7217H6.0408V14.4994ZM13.5874 10.9441H11.7007V9.16639H13.5874V10.9441ZM9.81409 10.9441H7.92744V9.16639H9.81409V10.9441ZM6.0408 10.9441H4.15415V9.16639H6.0408V10.9441Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGrey2);
export default __webpack_public_path__ + "static/media/calendarGrey2.30a7bcc554f77e9ab010241951e025e7.svg";
export { ForwardRef as ReactComponent };